import React from 'react';

import { withTextSelection } from '../../../../hocs/withTextSelection';

import RichTextArea from '../../../../design-system/RichTextArea/RichTextArea';

const StaticContentPiece = ({ content, logFeedbackTrigger }) => {
    const { value } = content;

    return (
        <div className="flex gap-2 items-start">
            <div className="flex-1">
                <RichTextArea value={value} previewOnly autoExpand isBorderHidden />
            </div>

            {logFeedbackTrigger}
        </div>
    );
};

const QuotableStaticContentPiece = withTextSelection(StaticContentPiece);

const FeedbackAwareStaticContentPiece = (props) => {
    const { feedbackAllowed } = props;

    if (feedbackAllowed) {
        return <QuotableStaticContentPiece {...props} />;
    }

    return <StaticContentPiece {...props} />;
};

export default FeedbackAwareStaticContentPiece;
